import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as platform from '../helpers/platformApi';
import { fetchCustomers, setActiveCustomerAndFetchLinkedUsers, } from '../reducers/client';
import styles from '../styles/form.scss';
import ListSelect from './ListSelect';
import { CompanyIcon } from './icons';
const CustomerSelect = () => {
    const dispatch = useDispatch();
    const customers = useSelector((state) => state.client.customers);
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc);
    useEffect(() => {
        dispatch(fetchCustomers());
    }, []);
    const availableCustomers = customers.map((c) => {
        return {
            title: c.company,
            text: `${c.firstName} ${c.lastName}`,
            value: c.id,
        };
    });
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_small }, "Select the account you'd like to use"),
                    React.createElement("div", { className: styles.form_body },
                        React.createElement(ListSelect, { items: availableCustomers, itemSelected: (value) => {
                                platform.hasSelectedTeam(value);
                                dispatch(setActiveCustomerAndFetchLinkedUsers(value));
                            }, icon: CompanyIcon })))))));
};
export default CustomerSelect;
